import React, { useState, useEffect } from "react";
import {
  Grid,
  Checkbox,
  TextareaAutosize,
  Typography,
  Button,
  List,
  ListItem
} from "@material-ui/core";
import { Link, useHistory } from "react-router-dom";

import PageHeader from "../../../Components/PageHeader";
import LeftControl from "../../../Components/LeftControl";

import { Imports } from '../../../Imports';

import Services from '../../../Services';
import { paths } from "../Application/path";
import SidebarApplicants from "../../../Components/SidebarApplicants";


const {
  users,
  Storage,
} = Services;

const Documents = (props) => {
  const history = useHistory();
  const storage = new Storage();


  const submitStep2 = async ($e) => {
    try {
      const { data } = await users.postStep2();

      storage.set(
        'user_profile',
        JSON.stringify(data)
      );

      history.push({
        pathname: '/submission',
        state: {
          approved: false,
          step: 1,
          applyToStorage: {
            user_profile: {
              ...data,
              EmployeeStatusId: 3,
            }
          }
        }
      })

    } catch (exc) {
       
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
     
    let user = JSON.parse(localStorage.getItem('user_profile'));
    if (user) {
      var { ApplicantStatusId } = user;
      if (props.status !== ApplicantStatusId) {
        history.push({
          pathname: paths[ApplicantStatusId],
          state: {
            approved: false,
            step: 1,
            applyToStorage: {
              user_profile: {
                ...user,
                EmployeeStatusId: 3,
              }
            }
          }
        })
      }
    }
  }, []);



  return (
    <Grid container xs={12} className="Liq-Container HRPortal">
      <Grid xs={12} md={2} className="LeftContol" id="LeftContol">
        <SidebarApplicants />
      </Grid>
      <Grid xs={12} md={10} container justify="center" className="PageContent">
        <Grid className="PagesFrame">
          <PageHeader />
          <Grid id="PageTitle" className="f16">Complete Onboarding Document</Grid>
          {/* Page Start */}
          <Grid xs={12} className="ContentPage FormTableArea">
            <Grid xs={12} className="StepsLine Step2Line">
              <List>
                <ListItem className="StepComplete">Step 1</ListItem>
                <ListItem className="StepComplete">Step 2</ListItem>
                <ListItem>Step 3</ListItem>
              </List>
            </Grid>
            <Grid xs={12}>
              <Grid xs={12} md={8} lg={6}>
                {/* <Typography variant="h1" component="h2" className="bold f16">
                  You're required to fill out the following documents to complete your application
                </Typography> */}
                <Typography variant="h1" component="h2" className="bold f16 mt40">
                  Section 2
                </Typography>

                <Typography style={{ marginTop: '20px' }} to="" className="DocDownload">
                  <Grid className="FileName">
                    Employee Data Sheet & Question
                  </Grid>
                  <p className="DocDownloadd"></p>
                </Typography>
                <Typography style={{ marginTop: '20px' }} to="" className="DocDownload">
                  <Grid className="FileName">
                    Application For Employment
                  </Grid>
                  <p className="DocDownloadd"></p>
                </Typography>
                {/* <Typography style={{marginTop:'20px'}} to="" className="DocDownload">
                  <Grid className="FileName">
                    Driver License
                  </Grid>
                  <Button></Button>
                </Typography> */}

              </Grid>
              <Grid style={{ marginTop: '20px' }} xs={12} className="mt50">
                <Grid xs={12} md={8} lg={6} container justify="space-between">
                  {/* <Link to="/questionnaire" className="LinkButtonBack">Back</Link> */}
                  <Button className="LinkButton"
                    onClick={submitStep2}>Submit Application To HR</Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          {/* Page Start End */}
        </Grid>
      </Grid>
    </Grid>
  );
}

export default Documents;
